<template >
  <div class="mainbody" v-if="initDatas">
    <div class="top">
      <h3 class="title">问卷详情</h3>
      <div class="btn-group-custom">
        <!-- <el-button type="text">删除</el-button> -->
      </div>
    </div>
    <div class="aLine"></div>
    <div class="box">
      <div class="list" >
        <div class="item" v-for="item in survey_info['fields']" :key="item.id">
          <span v-if="item.type != 'description'">{{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import answerInfo from "@/components/survey/answerInfo";

export default {
  components: {},
  props: {
    survey_info: {
      type: Object
    }
  },
  data() {
    return {
      initDatas: false,
      survey_id: null
    };
  },
  created() {
    this.initData();
  },
  activated() {
    this.initData();
  },
  methods: {
    initData() {
      this.initDatas = true;
      this.flag = false;
      if (
        localStorage.getItem("survey_id") ||
        localStorage.getItem("survey_id") != ""
      ) {
        this.survey_id = localStorage.getItem("survey_id");
      } else {
        this.$message({
          message: "问卷不存在"
        });
      }
    },
    getSurvey() {
      this.$api
        .surveyInfo({
          token: localStorage.getItem("token"),
          survey_id: this.survey_id
        })
        .then(({ data }) => {
          if (data.Data.fields) {
            this.flag = true;
          }
          this.survey_info = data.Data;
        })
        .catch(({ error }) => {});
    }
  }
};
</script>

<style lang="less" scoped>
.top {
  position: relative;
}
.top .btn-group-custom {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  right: 32px;
}
.top .btn-group-custom .el-button--text {
  color: #595959;
}
.top .btn-group-custom .el-button--text:hover {
  color: #1890ff;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
}

.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .box {
  padding: 24px 32px;
}
.box .item {
  color: #595959;
  margin-bottom: 16px;
  display: flex;
}
.box .item .text {
  flex: 1;
}
.empty {
  color: rgb(148, 148, 148);
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/surveyInfo.vue